import React from 'react';
import { createRoot } from 'react-dom/client';
import ModalAlert from '../components/ModalAlert/ModalAlert';

// Crear un div para el portal del modal alert
let alertRootElement;
let alertRoot;

// Inicializar el modal alert root solo en el cliente (no en SSR)
if (typeof document !== 'undefined') {
  alertRootElement = document.getElementById('modal-alert-root');
  
  if (!alertRootElement) {
    alertRootElement = document.createElement('div');
    alertRootElement.id = 'modal-alert-root';
    document.body.appendChild(alertRootElement);
  }
  
  // Crear la raíz una sola vez
  alertRoot = createRoot(alertRootElement);
}

// Estado global para el modal alert
let alertState = {
  isOpen: false,
  title: { text: '', highlight: '' },
  message: '',
  confirmText: 'Accept',
  cancelText: 'Cancel',
  onConfirm: () => {},
  onClose: () => {},
  acecept: false,
  onAccept: () => {}
};

// Función para renderizar el modal alert
const renderAlert = () => {
  if (alertRoot) {
    alertRoot.render(
      <ModalAlert
        isOpen={alertState.isOpen}
        onClose={alertState.onClose}
        title={alertState.title}
        message={alertState.message}
        confirmText={alertState.confirmText}
        cancelText={alertState.cancelText}
        onConfirm={alertState.onConfirm}
        acecept={alertState.acecept}
        onAccept={alertState.onAccept}
      />
    );
  }
};

// Función para mostrar el modal alert
const showAlert = ({
  title = { text: '', highlight: '' },
  message = '',
  confirmText = 'Accept',
  cancelText = 'Cancel',
  onConfirm = () => {},
  acecept = false,
  onAccept = () => {}
}) => {
  alertState = {
    ...alertState,
    isOpen: true,
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    acecept,
    onAccept,
    onClose: () => hideAlert()
  };
  renderAlert();
};

// Función para ocultar el modal alert
const hideAlert = () => {
  alertState = {
    ...alertState,
    isOpen: false
  };
  renderAlert();
};

// Función para mostrar un modal alert de confirmación
const showConfirmationAlert = ({
  title = { text: 'Confirm ', highlight: 'action' },
  message = 'Are you sure you want to continue with this action?',
  confirmText = 'Yes',
  cancelText = 'No',
  onConfirm = () => {}
}) => {
  showAlert({
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    acecept: false
  });
};

// Función para mostrar un modal alert con opción de aceptar
const showAcceptAlert = ({
  title = { text: 'Accept ', highlight: 'terms' },
  message = 'Do you accept the terms and conditions?',
  confirmText = 'Accept',
  cancelText = 'Decline',
  onAccept = () => {}
}) => {
  showAlert({
    title,
    message,
    confirmText,
    cancelText,
    acecept: true,
    onAccept
  });
};

// Exportar las funciones
const HandleAlert = {
  showAlert,
  hideAlert,
  showConfirmationAlert,
  showAcceptAlert
};

export default HandleAlert;